/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type ActionModuleKind = typeof ActionModuleKind[keyof typeof ActionModuleKind];


export const ActionModuleKind = {
  LIVE: 'LIVE',
  COMPANY_TEMPLATE: 'COMPANY_TEMPLATE',
  GLOBAL_TEMPLATE: 'GLOBAL_TEMPLATE',
} as const;
